import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat.js'
import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'
import buddhistEra from 'dayjs/plugin/buddhistEra'
import 'dayjs/locale/th'
dayjs.locale('th')

dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(buddhistEra)

export default dayjs
